import React, { FC, useState, useEffect, useContext } from 'react'
import platform from 'platform'
import { notify } from 'react-notify-toast'
import moment from 'moment'
import history from '../../../../history'
import { isMobile, isTablet } from 'react-device-detect'
import { usePromiseTracker, trackPromise } from 'react-promise-tracker'
import GenericCard from '../../../../GenericComponents/GenericMainCard'

import {
  getUserData,
  checkUserSubscriptionStatus,
  getPortalInfo,
  getPromoInfo,
} from '../../../../Api/backendApi'

import { getUserChallengeSubs } from '../../../../Api/challengesApi'
import Modal from 'react-responsive-modal'

import Loader from '../../../Loader/Loader'
import GenericTextSpan from '../../../../GenericComponents/GenericTextSpan'
import GenericRow from '../../../../GenericComponents/GenericRow'
import GenericButton from '../../../../GenericComponents/GenericButton'
import GenericCloseButton from '../../../../GenericComponents/GenericCloseButton'

import {
  SingleSettingModalBox,
  UserDataContainer,
} from '../../style/UserProfileStyle'
import GenericColumn from '../../../../GenericComponents/GenericColumn'

interface ManageSubInterface {
  closeModal: Function
  isChallengeMode?: boolean
}

const ManageSub: FC<ManageSubInterface> = ({ closeModal, isChallengeMode }) => {
  const [userData, setUserData] = useState(Object)
  const [userSubStatus, setUserSubStatus] = useState(Object)
  const [portalInfo, setPortalInfo] = useState(Object)
  const { promiseInProgress } = usePromiseTracker()
  const [challengeSubs, setChallengeSubs] = useState<any>()
  const [promoInfo, setPromoIfno] = useState(null)
  const [openPromoInfoModal, setOpenPromoInfoModal] = useState(false)

  const modalStyles = {
    closeButton: {
      display: 'none',
    },
    modal: {
      maxWidth: 'unset',
      width: isMobile || isTablet ? '95vw' : '45vw',
      overflow: 'unset',
      left: '0',
      boxsizing: 'border-box',
      margin: isMobile || isTablet ? 'auto' : 'unset',
      borderRadius: '30px',
    },
  }

  const getUser = async () => {
    const result: any = await getUserData()

    setUserData(result)
  }

  const getUserChallengesub = async () => {
    const subs = await getUserChallengeSubs()

    setChallengeSubs(subs)
  }

  const getUserSubStatus = async () => {
    const userSubStatus: any = await checkUserSubscriptionStatus()

    setUserSubStatus(userSubStatus)
  }

  const redirectUserToPortal = async () => {
    const result: any = await trackPromise(getPortalInfo())

    if (result && result.url) {
      window.location.href = result.url
    }
  }
  const obtainPromoInfo = async () => {
    const promoInfo: any = await getPromoInfo()

    promoInfo && setPromoIfno(promoInfo)
  }

  const handleManageSub = () => {
    if (promoInfo && promoInfo.promo_status == 'STRIPE_SUBSCRIPTION_ACTIVE') {
      setOpenPromoInfoModal(true)
    } else {
      redirectUserToPortal()
    }
  }

  useEffect(() => {
    ;(async () => {
      getUser()
      getUserSubStatus()
    })()
    obtainPromoInfo()
  }, [])

  useEffect(() => {
    getUserChallengesub()
  }, [])

  return (
    <SingleSettingModalBox>
      <GenericCloseButton onClick={closeModal} />
      <GenericRow margin={'0% 0 3% 0'}>
        <GenericTextSpan fSize={'2rem'} fWeight={'bold'}>
          {isChallengeMode
            ? 'Twoje aktywne pakiety wyzwań'
            : 'Twoja subskrypcja'}
        </GenericTextSpan>
      </GenericRow>
      {!isChallengeMode && (
        <GenericRow>
          <GenericTextSpan
            fSize={isMobile ? '1.3rem' : '1rem'}
            width={isMobile ? '90%' : '60%'}
          >
            Twoja subskrypcja MIAZGA by FMW jest aktywna do dnia:{' '}
            <span className={'accent-color '}>
              {' '}
              {userSubStatus.subscription &&
                userSubStatus.subscription.expiration_date}
            </span>
          </GenericTextSpan>
        </GenericRow>
      )}

      {!isChallengeMode && (
        <GenericRow>
          <GenericTextSpan
            fSize={isMobile ? '1.7rem' : '1.4rem'}
            margin={'3% 0 0 0'}
            fWeight={'bold'}
            width={isMobile ? '90%' : '60%'}
          >
            Zarządzanie subskrypcją
          </GenericTextSpan>
        </GenericRow>
      )}

      {!isChallengeMode && (
        <GenericButton
          width={isMobile ? '90%' : '50%'}
          className="standard"
          margin={'4% auto'}
          justify={'center'}
          onClick={handleManageSub}
        >
          Zarządzaj subskrypcją
        </GenericButton>
      )}

      {!isChallengeMode && (
        <GenericRow>
          <GenericTextSpan
            fSize={isMobile ? '1.7rem' : '1.4rem'}
            margin={'0% 0 0 0'}
            fWeight={'bold'}
            width={isMobile ? '90%' : '60%'}
          >
            Chcesz wydłużyć subskrypcję?
          </GenericTextSpan>
        </GenericRow>
      )}

      {!isChallengeMode && (
        <GenericButton
          width={isMobile ? '90%' : '50%'}
          className="standard"
          margin={'4% auto'}
          justify={'center'}
          onClick={() => history.push('/wybierz-plan/sub')}
        >
          Kup subskrypcje
        </GenericButton>
      )}

      {isChallengeMode &&
        challengeSubs &&
        challengeSubs.data.map((sub: any) => (
          <GenericRow className="sub" wrap="wrap" margin="1% 0">
            <GenericRow>
              <GenericTextSpan fSize="1.4rem" fWeight="bold" color="white">
                {sub.album}
              </GenericTextSpan>
            </GenericRow>
            <GenericRow margin="2% 0">
              <GenericColumn>
                <GenericTextSpan color="white" width="100%" tAlign="center">
                  <b>start pakietu: </b> {sub.start_date}
                </GenericTextSpan>
              </GenericColumn>
            </GenericRow>
            <GenericRow>
              <GenericColumn>
                <GenericTextSpan color="white" width="100%" tAlign="center">
                  <b>koniec pakietu:</b> {sub.expiration_date}
                </GenericTextSpan>
              </GenericColumn>
            </GenericRow>
          </GenericRow>
        ))}
      {promiseInProgress && <Loader />}
      <Modal
        open={openPromoInfoModal}
        animationDuration={700}
        onClose={() => setOpenPromoInfoModal(false)}
        center
        styles={modalStyles}
      >
        <GenericCard
          flexDir={'column'}
          className="promo-modal"
          width={'100%'}
          margin={' auto'}
        >
          <GenericRow margin={'0% 0 1% 0'}>
            <GenericTextSpan
              fSize={isMobile ? '1.5rem' : '2rem'}
              fWeight={'bold'}
            >
              Promocja TRWA
            </GenericTextSpan>
          </GenericRow>
          <GenericRow margin={'3% 0 1% 0'}>
            <GenericTextSpan
              fSize={isMobile ? '1.2rem' : '1.3rem'}
              fWeight={'bold'}
              color="#E39401"
            >
              Promocja naliczy się automatycznie
            </GenericTextSpan>
          </GenericRow>
          <GenericColumn>
            <GenericTextSpan
              lineHeight="1.5rem"
              fSize="1.2rem"
              margin="5% 2% 0 5%"
            >
              Twoja subskrypcja jest aktywna i{' '}
              <b className="green">
                {' '}
                automatycznie odnowi się{' '}
                {userSubStatus &&
                  userSubStatus.subscription &&
                  userSubStatus.subscription.expiration_date &&
                  moment(userSubStatus.subscription.expiration_date).format(
                    'DD MMMM YYYY'
                  )}
              </b>{' '}
              na 2 miesiące w cenie 1!
            </GenericTextSpan>
            {/* <GenericTextSpan
              lineHeight="1.8rem"
              fSize="1.6rem"
              margin="3% 2% 0 8%"
            >
              Promocja zostanie dodana automatycznie 22 maja.
            </GenericTextSpan> */}
          </GenericColumn>
          <GenericRow margin="5% 0 1.5% 0">
            <GenericButton
              margin="0 2% 0 2%"
              className="promo-fill-btn"
              width="45%"
              onClick={() => setOpenPromoInfoModal(false)}
            >
              ZAMKNIJ
            </GenericButton>
            <GenericButton
              className="promo-outline-btn"
              margin="0 2% 0 2%"
              width="48%"
              onClick={() => redirectUserToPortal()}
            >
              Przejdź mimo to
            </GenericButton>
          </GenericRow>
        </GenericCard>
      </Modal>
    </SingleSettingModalBox>
  )
}

export default ManageSub
